<template>
  <div>
    <div
      v-if="isDownloadingPDF"
      style="width:100%"
      class="pdf-spinner-overlay"
    >
      <span class="loader" />
    </div>
    <img
      style="cursor:pointer;"
      src="@/assets/images/pdf-invoice-logo.svg"
      @click="downloadProductionPDF(itemOrderId, itemOrderNumber)"
    >
    <div class="d-none">
      <XharraIconBase64 ref="xharraIconBase64" />
      <IconLogoBase64 ref="iconLogoBase64" />
      <QrCodeLogoBase64 ref="qrCodeLogoBase64" />
      <FacebookLogoBase64 ref="facebookLogoBase64" />
      <InstaLogoBase64 ref="instaLogoBase64" />
      <MailLogoBase64 ref="mailLogoBase64" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment/moment';
import XharraIconBase64 from '@/components/PdfDocument/xharraIconBase64.vue';
import IconLogoBase64 from '@/components/PdfDocument/IconLogoBase64.vue';
import QrCodeLogoBase64 from '@/components/PdfDocument/QrCodeLogoBase64.vue';
import FacebookLogoBase64 from '@/components/PdfDocument/FacebookLogoBase64.vue';
import InstaLogoBase64 from '@/components/PdfDocument/InstaLogoBase64.vue';
import MailLogoBase64 from '@/components/PdfDocument/MailLogoBase64.vue';
import jsPDF from 'jspdf';
import { client } from '@/domainConfig'

export default {
  components: {
    XharraIconBase64,
    IconLogoBase64,
    QrCodeLogoBase64,
    FacebookLogoBase64,
    InstaLogoBase64,
    MailLogoBase64,
  },
  props: ['itemOrderId', 'itemOrderNumber'],
  data() {
    return {
      orderNumberClient: null,
      isDownloadingPDF: false,
      orderNumber: null,
      client: client.clientName,
      stateType: client.stateType,
      addressOfStore: null,
      phoneOfClient: null,
      emailOfClient: null,
      nameOfClient: null,
      sewingTypes: [
        {
          name: 'Sistemi Amerikan 3m', value: 'American_3m', meter: 3, materialVariantId: 'cd9e5ed2-df10-4ba4-a6db-08dd09677ee2', materialVariantName: 'Shiritat Amerikan',
        },
        {
          name: 'Sistemi Amerikan 2.8m', value: 'American_2_8m', meter: 2.8, materialVariantId: 'cd9e5ed2-df10-4ba4-a6db-08dd09677ee2', materialVariantName: 'Shiritat Amerikan',
        },
        {
          name: 'Fallta te rregullta 3m', value: 'FalltaReglar_3m', meter: 3, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta te rregullta 2.5m', value: 'FalltaReglar_2_5m', meter: 2.5, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta te rregullta 2m', value: 'FalltaReglar_2m', meter: 2, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta Zvicrrane 3m', value: 'FalltaSwiss_3m', meter: 3, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Fallta Zvicrrane 2.7m', value: 'FalltaSwiss_2_7m', meter: 2.7, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Fallta Zvicrrane 2m', value: 'FalltaSwiss_2_5m', meter: 2.5, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Qepje me vega 2.5m', value: 'Veg_2_5m', meter: 2.5, materialVariantId: '70ff128e-c889-424a-a6ed-08dd09677ee2', materialVariantName: 'Shirita me vega',
        },
        {
          name: 'Qepje Fallta me vrime 3m', value: 'Holes_3m', meter: 3, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Qepje Fallta me vrime 2.5m', value: 'Holes_2_5m', meter: 2.5, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Qepje me rrudhje 4m', value: 'Wrinkle_4m', meter: 4, materialVariantId: 'f4ad44f0-55f5-476c-a6ef-08dd09677ee2', materialVariantName: 'Shirita me rrudha',
        },
        {
          name: 'Qepje me rrudhje 3m', value: 'Wrinkle_3m', meter: 3, materialVariantId: 'f4ad44f0-55f5-476c-a6ef-08dd09677ee2', materialVariantName: 'Shirita me rrudha',
        },
        {
          name: 'Qepje shirit drejt', value: 'StraightBand', meter: 1, materialVariantId: '0974f5ce-e07e-4ac0-a6f0-08dd09677ee2', materialVariantName: 'Shirita drejt',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['getNewInvoiceByOrderIdOther']),
  },
  methods: {
    ...mapActions(['loadInvoiceByOrderIdOther']),
    downloadProductionPDF(orderId, orderNumber) {
      this.orderNumberClient = orderId
      this.dateOfCreated = orderNumber
      this.isDownloadingPDF = true
      this.loadInvoiceByOrderIdOther({
        orderId,
      })
        .then(() => {
          const invoice = this.getNewInvoiceByOrderIdOther

          const tableContent = this.generateInvoiceTableContentOther(invoice)

          const xharraIcon = this.$refs.xharraIconBase64.getBase64Image();
          const iconLogo = this.$refs.iconLogoBase64.getBase64Image()
          const qrCodeLogo = this.$refs.qrCodeLogoBase64.getBase64Image()
          const facebookLogo = this.$refs.facebookLogoBase64.getBase64Image()
          const instaLogo = this.$refs.instaLogoBase64.getBase64Image()
          const mailLogo = this.$refs.mailLogoBase64.getBase64Image()

          const pdfDocument = this.generateInvoiceOther(tableContent, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800)
          this.isDownloadingPDF = false

          pdfDocument.save(`Invoice-${moment()
            .format('DD/MM/YYYY - hh:mm:s')}.pdf`)
        })
        .catch((error) => {
          this.isDownloadingPDF = false;
          console.error('Error downloading the data:', error);
        });
    },
    generateInvoiceTableContentOther(invoice) {
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Unit1')}`,
        `${this.$t('Quantity')}`,
      ];

      const {
        storeDetailResponseDto,
        windowProductionDetailsByOrderIdRespDtos,
        ordeNumber,
        description,
      } = invoice;

      this.addressOfStore = {
        street: storeDetailResponseDto?.street || this.$t('NotFound'),
        city: storeDetailResponseDto?.city || this.$t('NotFound'),
        postalCode: storeDetailResponseDto?.postalCode || this.$t('NotFound'),
        country: storeDetailResponseDto?.country || this.$t('NotFound'),
        storeName: storeDetailResponseDto?.storeName || this.$t('NotFound'),
      }

      this.orderNumber = ordeNumber;
      this.sellDate = storeDetailResponseDto?.sellDate;
      this.remark = description || '';

      const preTableInfo = [];
      const groupedBody = [];

      windowProductionDetailsByOrderIdRespDtos.forEach((windowItem) => {
        preTableInfo.push({
          articleName: windowItem.articleName,
          width: windowItem.width,
          height: windowItem.height,
          sewingType: windowItem.sewingType,
          hingeType: windowItem.hingeType,
        });

        const rows = windowItem.windowItemIdAndMaterialVariantResponseDtos.map((variant, subIndex) => {
          return [
            subIndex + 1,
            variant.name,
            this.$t(variant.measurementType || 'N/A'),
            variant.quantity,
          ];
        });

        groupedBody.push(rows);
      });

      return {
        headers,
        groupedBody,
        preTableInfo,
      };
    },
    generateInvoiceOther(tableContent, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instagramLogo, mailLogo, customWidth) {
      const {
        headers,
        groupedBody,
        preTableInfo,
      } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const headerContent = () => {
        const title = this.$t('ProductionInvoice');
        const titleY = 90;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 50;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        const from = this.$t('From');
        const fromY = 160;
        const fromX = 40;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(from, fromX, fromY, { align: 'left' });

        const lineStartX = fromX;
        const lineEndX = 300;
        const lineY = fromY + 5;
        doc.setDrawColor(160, 160, 160);
        doc.setLineWidth(0.3);
        doc.line(lineStartX, lineY, lineEndX, lineY);

        const author4X = fromX;
        const author4Y = 180;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(`${this.client}`, author4X, author4Y);

        let phone;
        let email;
        let url;
        if (this.client === 'NotaBrillant') {
          phone = '+383 44 117 090';
          email = 'kujdesi@nota-brillant.com';
          url = 'nota-brillant.com';
        } else {
          phone = '+383 49 999 433';
          email = 'contacts@digitbusiness.ch';
          url = 'digitbusiness.ch';
        }

        const phoneX = fromX;
        const phoneY = 200;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(phone, phoneX, phoneY);

        const emailX = fromX;
        const emailY = 220;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(email, emailX, emailY);

        const addressX = fromX;
        const addressY = 240;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(
          `${this.addressOfStore?.city}, ${this.addressOfStore?.street}, ${this.$t('Filiale')}:${this.addressOfStore?.storeName}`,
          addressX,
          addressY,
        );

        const urlX = fromX;
        const urlY = 260;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(url, urlX, urlY);

        const date = this.$t('PrintingDate');
        const dateY = 180;
        const dateX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(date, dateX, dateY, { align: 'left' });

        const todayDate = `${this.$t(moment()
          .format('dddd'))}, ${moment()
          .format('DD-MM-YYYY')}`;
        const todayDateY = dateY + 17;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(todayDate, dateX, todayDateY, { align: 'left' });

        const order = this.$t('OrderNumber');
        const orderY = 215;
        const orderX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(order, orderX, orderY, { align: 'left' });

        const author14X = 400;
        const author14Y = 235;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.orderNumber}`, author14X, author14Y, { align: 'left' });
      }

      groupedBody.forEach((windowGroup, index) => {
        if (index > 0) doc.addPage();
        if (index === 0) headerContent()
        const preInfo = preTableInfo[index];
        const y = index === 0 ? 300 : 150;

        if (preInfo) {
          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0);
          doc.text(`${this.$t('Position')}: ${preInfo.articleName}`, 40, y);
          doc.text(`${this.$t('Dimensions')}:`, 40, y + 20);
          doc.text(`${this.$t('Width')}: ${preInfo.width}`, 40, y + 40);
          doc.text(`${this.$t('Height')}: ${preInfo.height}  `, 40, y + 60);
          const sewingType = this.sewingTypes.find(type => { return type.value === preInfo.sewingType });
          const sewingTypeName = sewingType ? sewingType.name : '-';
          doc.text(`${this.$t('SewingType')}: ${sewingTypeName}`, 40, y + 80);
          const hingeTypeLabel = preInfo.hingeType ? this.$t(`${preInfo.hingeType}`) : '-';
          doc.text(`${this.$t('HingType')}: ${hingeTypeLabel}`, 40, y + 100);
        }

        doc.autoTable({
          startY: y + 120,
          head: [headers],
          body: windowGroup,
          headStyles: {
            fillColor: [249, 249, 249],
            textColor: [96, 96, 96],
            lineColor: [181, 181, 181],
            lineWidth: 0.1,
            halign: 'left',
          },
          bodyStyles: {
            textColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          columnStyles: {
            0: { columnWidth: doc.internal.pageSize.getWidth() / 20 },
            1: { columnWidth: doc.internal.pageSize.getWidth() / 3 },
            2: { columnWidth: doc.internal.pageSize.getWidth() / 4 },
            3: { columnWidth: doc.internal.pageSize.getWidth() / 4 },
          },
        });
      });

      const tableEndY = doc.lastAutoTable.finalY;
      const lineStartTabX = 40;
      const lineEndTabX = doc.internal.pageSize.getWidth() - 40;
      const lineTabY = tableEndY + 26;

      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.2);
      doc.line(lineStartTabX, lineTabY, lineEndTabX, lineTabY);

      const addressX1 = 40;
      const addressY1 = lineTabY + 5;
      const rectWidth = 668;
      const rectHeight = 90;

      doc.setFontSize(10);

      doc.setFillColor(255, 200, 200);
      doc.rect(addressX1, addressY1, rectWidth, rectHeight, 'F');

      doc.setTextColor(255, 255, 255);
      const labelAndRemark = `${this.$t('InvoiceRemarkProduction')}: ${this.remark}`;

      const textWidth = rectWidth - 10;

      doc.text(labelAndRemark, addressX1 + 5, addressY1 + 15, { maxWidth: textWidth, align: 'left' });

      return doc;
    },
  },
}
</script>

<style scoped lang="scss">
</style>
